import React from 'react'
import './footer.css'
import FooterImg from '../../Images/trafalgar.png'

function Footer() {
  return (
    <div className='body'>
      <div className='row doh'>
        <div className='col-sm-12 col-md-12 col-lg-4'>
          <img src={FooterImg} alt="" />
          <p className='far'>Trafalgar provides progressive, and affordable healthcare, accessible on mobile and online <br/> for everyone</p>
          <p className='par'>©Trafalgar PTY LTD 2020. All rights reserved</p>
        </div>
        <div className='row soh'>
            <div className='col-sm-12 col-md-12 col-lg-2.5'>
              <p className='bob'>Company</p>
              <p className='sob'>About</p>
              <p className='sob'>Testimonials</p>
              <p className='sob'>Find a doctor</p>
              <p className='sob'>Apps</p>

            </div>
        </div>
     
        <div className='row sah'>
            <div className='col-sm-12 col-md-12 col-lg-2.5'>
              <p className='bob'>Region</p>
              <p className='sob'>Indonesia</p>
              <p className='sob'>Singapore</p>
              <p className='sob'>Hongkong</p>
              <p className='sob'>Canada</p>
            </div>
        </div>
        <div className='row snap'>
          <div className='col-sm-12 col-md-12 col-lg-2.5'>
            <p className='bob'>Help</p>  
            <p className='sob'>Help center</p>
            <p className='sob'>Contact support</p>
            <p className='sob'>Instructions</p>
            <p className='sob'>How it works</p>
          </div>
        </div>
      </div>  
    </div>
  )
}

export default Footer
